module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "elevation-0",
    attrs: {
      "color": "white",
      "fixed": "",
      "app": "",
      "clipped-right": ""
    }
  }, [(_vm.$store.state.sidenav) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$store.commit('toggleSidenav')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "text--white"
  }, [_c('router-link', {
    staticClass: "white--text",
    attrs: {
      "to": '/'
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.reload()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('span', [_vm._v("Actualizar la página completa")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-fullscreen",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.fullscreen()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("fullscreen")]), _vm._v(" "), _c('v-icon', [_vm._v("fullscreen_exit")])], 1), _vm._v(" "), _c('span', [_vm._v("Pantalla completa")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-title', {
    on: {
      "click": function($event) {
        return _vm.$router.push('account')
      }
    }
  }, [_c('v-icon', [_vm._v("account_circle")]), _vm._v(" " + _vm._s(_vm.$t('app.account')))], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-title', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('v-icon', [_vm._v("")]), _vm._v(" " + _vm._s(_vm.$t('app.logOut')))], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c9ddf32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/layout/AppNavbar.vue
// module id = 510
// module chunks = 2